import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { alertState } from "./AlertDisplay/AlertDisplay.state";
import { useTranslation } from "react-i18next";
import { getErrorMessage } from "../lib/error";

const ErrorAlert = ({ error }) => {
  const setAlert = useSetRecoilState(alertState)
  const { t } = useTranslation()
  useEffect(() => {
    // Prefer API-provided message when available; otherwise fallback to generic message
    const message = getErrorMessage(error)

    setAlert({ type: "error", message, closable: true })
  }, [error, setAlert, t])

  return null
}

export default ErrorAlert;
